var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Select, Store, Actions, ofActionDispatched } from '@ngxs/store';
import { EngineState } from 'src/app/engine/state/engine.state';
import { Observable, Subject } from 'rxjs';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { ToolEnum } from 'src/app/engine/models/tool.enum';
import { filter, takeUntil } from 'rxjs/operators';
import { AddLabel, SelectLabel, AddContextLabel, RemoveContextLabel } from 'src/app/story/state/labels/story.labels.actions';
import { CameraService } from 'src/app/engine/camera.service';
import { ClickNode } from 'src/app/engine/state/engine.actions';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { EngineCameraState } from 'src/app/engine/state/camera/engine.camera.state';
import { SetCamera } from 'src/app/engine/state/camera/engine.camera.actions';
import * as _ from 'lodash';
import { LabelsService } from 'src/app/story/labels.service';
import { LabelThemeEnum } from 'src/app/story/models/labels/label-theme.enum';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';
import { ErrandType } from 'src/app/story/models/errands/errand-type.enum';
import { FlyToObjectErrandModel } from 'src/app/story/models/errands/fly-to-object-errand.model';
import { FlyToChapterErrandModel } from 'src/app/story/models/errands/fly-to-chapter-errand.model';
var LabelsComponent = /** @class */ (function () {
    function LabelsComponent(store, action$, cameraService, changeDetector, labelsService) {
        this.store = store;
        this.action$ = action$;
        this.cameraService = cameraService;
        this.changeDetector = changeDetector;
        this.labelsService = labelsService;
        this.interactive = false;
        this.ngUnsubscribe = new Subject();
    }
    LabelsComponent.prototype.ngOnInit = function () {
        this.bindApplicationEvents();
    };
    LabelsComponent.prototype.ngOnDestroy = function () {
        this.changeDetector.detach();
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    LabelsComponent.prototype.bindApplicationEvents = function () {
        var _this = this;
        // Listen for node click
        this.action$
            .pipe(ofActionDispatched(ClickNode), takeUntil(this.ngUnsubscribe))
            .subscribe(function (action) {
            _this.handleClickNode(action);
        });
        // Change detection
        this.labels$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.changeDetector.markForCheck();
        });
        // Handle label deselection
        this.selectedLabel$
            .pipe(filter(function (label) { return label == null; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (label) {
            var zoomed = _this.store.selectSnapshot(EngineCameraState.getZoomed);
            var lockCamera = _this.store.selectSnapshot(EngineCameraState.getLockCamera);
            if (zoomed && !lockCamera) {
                _this.resetCamera();
            }
        });
        // Listen for ready state before showing
        this.selectedChapter$.pipe(filter(function (chapter) { return chapter != null; }), takeUntil(this.ngUnsubscribe)).subscribe(function (chapter) {
            _this.interactive = chapter.readyState.model;
        });
    };
    LabelsComponent.prototype.handleClickNode = function (action) {
        var _this = this;
        var tool = this.store.selectSnapshot(EngineState.getActiveTool);
        if (action.node != null) {
            if (tool === ToolEnum.Label) {
                this.addLabel(action.hit, action.node);
            }
            else {
                // Timeout to allow selected node to update
                setTimeout(function () {
                    _this.toggleContextLabel(action.hit, action.node);
                });
            }
        }
        else {
            this.store.dispatch(new SelectLabel(null));
            this.store.dispatch(new RemoveContextLabel());
        }
    };
    LabelsComponent.prototype.addLabel = function (hit, node) {
        var direction = this.cameraService.getDirection(hit);
        var label = this.getLabelDefaults(hit.objectId);
        var tagDistance = label.hideWire ? 20 : 32;
        label.title = node.label;
        label.offset = [tagDistance, 0];
        label.objectId = hit.objectId;
        label.barycentric = [hit.barycentric[0], hit.barycentric[1], hit.barycentric[2]];
        label.pos = [hit.worldPos[0], hit.worldPos[1], hit.worldPos[2]];
        label.primitiveIndex = hit.primitiveIndex;
        label.renderableIndex = hit.renderableIndex || 0;
        label.dir = direction;
        label.chapterId = this.store.selectSnapshot(StoryChaptersState.getSelectedChapter).id;
        label.occludable = true;
        this.store.dispatch(new AddLabel(label));
        this.store.dispatch(new SelectLabel(label));
    };
    LabelsComponent.prototype.toggleContextLabel = function (hit, node) {
        var nodeIds = this.store.selectSnapshot(EngineNodesState.getCheckedNodeIds);
        if (nodeIds.some(function (value) { return value === node.id; })) {
            var direction = this.cameraService.getDirection(hit);
            var label = this.labelsService.makeDefaultStudioLabel();
            label.theme = LabelThemeEnum.Context;
            label.title = node.label;
            label.offset = [4, 0];
            label.objectId = hit.objectId;
            label.barycentric = [hit.barycentric[0], hit.barycentric[1], hit.barycentric[2]];
            label.pos = [hit.worldPos[0], hit.worldPos[1], hit.worldPos[2]];
            label.primitiveIndex = hit.primitiveIndex;
            label.dir = direction;
            label.occludable = false;
            this.store.dispatch(new AddContextLabel(label));
        }
        else {
            this.store.dispatch(new RemoveContextLabel());
        }
    };
    LabelsComponent.prototype.getLabelDefaults = function (objectId) {
        // Label copy order of priority
        // 1. Selected
        // 2. Last in chapter
        // 3. Last in story
        // 4. New Studio Lbael
        var labelToCopy = this.store.selectSnapshot(StoryLabelsState.getSelectedLabel);
        if (labelToCopy == null) {
            // Get chapter labels
            var labels = this.store.selectSnapshot(StoryLabelsState.getChapterLabels);
            // Get story labels
            if (!labels || labels.length === 0) {
                labels = this.store.selectSnapshot(StoryLabelsState.getLabels);
            }
            // If labels, assign
            if (labels.length) {
                labelToCopy = _.cloneDeep(labels[labels.length - 1]);
            }
        }
        if (labelToCopy != null) {
            // Make a shallow copy of the most recent label
            var label = this.labelsService.makeDefaultStudioLabel();
            label.hideWire = labelToCopy.hideWire;
            label.pinGlow = labelToCopy.pinGlow;
            label.pinType = labelToCopy.pinType;
            label.theme = labelToCopy.theme;
            // Emulate previous labels actions, but overwrite targets
            // -- Default State
            label.states[0].errands[0] = new FlyToChapterErrandModel();
            // -- Selected State
            switch (_.get(labelToCopy, 'states[1].errands[0].type')) {
                case ErrandType.flyToObject:
                    label.states[1].errands[0] = new FlyToObjectErrandModel(objectId);
                    break;
                case ErrandType.flyToCamera:
                case ErrandType.flyToChapter:
                // noop
            }
            return label;
        }
        else {
            // New label
            var label = this.labelsService.makeDefaultStudioLabel();
            label.states[0].errands[0] = new FlyToChapterErrandModel();
            label.states[1].errands[0] = new FlyToObjectErrandModel(objectId);
            return label;
        }
    };
    LabelsComponent.prototype.trackLabel = function (index, label) {
        return label.id;
    };
    LabelsComponent.prototype.resetCamera = function () {
        var chapter = this.store.selectSnapshot(StoryChaptersState.getSelectedChapter);
        var location = _.get(chapter, 'camera.location');
        if (location) {
            this.store.dispatch(new SetCamera(chapter.camera.location));
        }
    };
    __decorate([
        Select(StoryLabelsState.getChapterLabels),
        __metadata("design:type", Observable)
    ], LabelsComponent.prototype, "labels$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapter),
        __metadata("design:type", Observable)
    ], LabelsComponent.prototype, "selectedChapter$", void 0);
    __decorate([
        Select(StoryLabelsState.getSelectedLabel),
        __metadata("design:type", Observable)
    ], LabelsComponent.prototype, "selectedLabel$", void 0);
    __decorate([
        Select(StoryLabelsState.getContextLabel),
        __metadata("design:type", Observable)
    ], LabelsComponent.prototype, "contextLabel$", void 0);
    __decorate([
        Select(EngineState.getShowLabels),
        __metadata("design:type", Observable)
    ], LabelsComponent.prototype, "showLabels$", void 0);
    __decorate([
        Select(EngineCameraState.getZoomed),
        __metadata("design:type", Observable)
    ], LabelsComponent.prototype, "zoomed$", void 0);
    __decorate([
        Select(StoryLabelsState.getEnableContextLabel),
        __metadata("design:type", Observable)
    ], LabelsComponent.prototype, "enableContextLabel$", void 0);
    return LabelsComponent;
}());
export { LabelsComponent };
